import * as Sentry from '@sentry/react';

export default function handleErrors(error: any) {
    if (error?.response.status !== 401) {
        Sentry.captureException(error);
    }
}
